export default __webpack_public_path__ + "static/media/WFLogo.3408a0ac.png";